"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = react_1.useState(value);
    react_1.useEffect(() => {
        const timeOut = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(timeOut);
        };
    }, [value, delay]);
    return debouncedValue;
};
exports.default = useDebounce;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGVib3VuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL3VzZURlYm91bmNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBR3lDO0FBRXpDLE1BQU0sV0FBVyxHQUFHLENBQUMsS0FBVSxFQUFFLEtBQWEsRUFBRSxFQUFFO0lBQzlDLE1BQU0sQ0FBQyxjQUFjLEVBQUUsaUJBQWlCLENBQUMsR0FBRyxnQkFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBRTVELGlCQUFTLENBQUUsR0FBRyxFQUFFO1FBQ1osTUFBTSxPQUFPLEdBQUcsVUFBVSxDQUFDLEdBQUcsRUFBRTtZQUM1QixpQkFBaUIsQ0FBRSxLQUFLLENBQUMsQ0FBQztRQUM5QixDQUFDLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFFVixPQUFPLEdBQUcsRUFBRTtZQUNSLFlBQVksQ0FBRSxPQUFPLENBQUMsQ0FBQztRQUMzQixDQUFDLENBQUM7SUFDTixDQUFDLEVBQ0QsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQ2IsQ0FBQztJQUVGLE9BQU8sY0FBYyxDQUFDO0FBQzFCLENBQUMsQ0FBQztBQUVGLGtCQUFlLFdBQVcsQ0FBQyJ9